import { render } from "./AgreementsContainer.vue?vue&type=template&id=18316e2a&scoped=true"
import script from "./AgreementsContainer.vue?vue&type=script&lang=js"
export * from "./AgreementsContainer.vue?vue&type=script&lang=js"

import "./AgreementsContainer.vue?vue&type=style&index=0&id=18316e2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18316e2a"]])

export default __exports__